export default __webpack_public_path__ + "static/media/gameover.5bbddb0f.mp3";